import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        url: String
    }

    navigate(event) {
        if (this.hasUrlValue) {
            Turbo.visit(this.urlValue)
        }
    }
}
